import React from 'react';
import TitleAlt from './../TitleAlt.jsx'

const Linkedin = ({LinkIcon}) => (
    <section className="linkedin">
        <img src={LinkIcon} alt={TitleAlt} />
            <p>
                <a href="https://linkedin.com/in/eliud-cesar">Linkedin</a>
            </p>
        <img src={LinkIcon} alt={TitleAlt} />
    </section>
)

export default Linkedin;

// https://raw.githubusercontent.com/eliud-cesar/data-base-cesar/b2503f7891fcd242849800cda37b83aa561c6e21/logos-reds-svg/linkedin-icon.svg
